export const OPERATION_TYPES = [
  'filter',
  'select',
  'group',
  'sort',
  'pivot',
  'join'
] as const
export const FILTER_OPERATORS = ['=', '!=', '>', '>=', '<', '<='] as const
export const AGGREGATE_FUNCTIONS = [
  'min',
  'max',
  'sum',
  'avg',
  'count'
] as const
export const JOIN_TYPES = ['INNER', 'LEFT', 'RIGHT', 'FULL'] as const
